import { Button, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import { useAuth } from "oidc-react";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Icon } from "@progress/kendo-react-common";
import { filterAllowedColumn, ShowError } from "../../../_helper/helper";
import EmployeeVerificationContext from "../../../_helper/Customizer";
import { Btn } from "../../../AbstractElements";
import { get } from "../../../_helper/api_helper";
import visileColumns from "./visibleColumns";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable/indexV2";
import { Dialog } from "@progress/kendo-react-dialogs";
import { loadingPanel } from "../../../CommonComponents/CommonFunction";
import PrintPDF from "../Printer/PrintPDF";
import Header from ".././commonComponenets/Header";
import Report from ".././Reports";
import TimesheetMain from "../../Timesheet/TimesheetMain";

const AllEarnings = () => {
  const {
    columns,
    loadingSearch,
    searchResults,
    searchParameter,
    ColumnsSorted,
    searchResultsV2,
    // : { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const id = "AllEarnings";
  const { userData } = useAuth();
  const dispatch = useDispatch();
  const earningReportData = useSelector(
    (state) => state.EmployeeEarningsReducer
  );
  const { loading } = useSelector((state) => state?.PayrollHeaderReducer);
  //   const { loadingSearch, } = useSelector((state) => state.advanceSearchv2Reducer);
  const [masterContData, setMasterContData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [deductionVendor, setDeductionVendor] = useState([]);
  const { toggleIcon, toggleSidebar } = useContext(EmployeeVerificationContext);
  const [earningLoader, setEarningLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [searchParams, setSearchParams] = useState([]);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [sortedColumns, setSortedColumns] = useState(visileColumns);
  const [vendorLoader, setVendorLoader] = useState(false);
  const [earningModal, setEarningModal] = useState({ show: false, userId: "" });
  const [openTimeSheet, setOpenTimeSheet] = useState(false);
  const [ppeEndDate, setPPEendDate] = useState(null);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  const viewEarningStatementHandler = async (statement) => {
    const { Check_Date, Check_Sequence,RunID, EmployeeId } = statement ?? {};
    setVendorLoader(true);
    try {
      const response = await get(
        `${process.env.REACT_APP_API_DOTNET_URL}/PayrollSummary/GetPayrollSummaryByfunction_historical?Check_date=${Check_Date}&Check_seq=${Check_Sequence}&RunID=${RunID}`
      );
      for (let responseItem of response) {
        for (let reponseItemKey in responseItem) {
          if (reponseItemKey != "federal_Additional_tax") {
            const capitalizedKey =
              reponseItemKey.charAt(0).toUpperCase() + reponseItemKey.slice(1);
            responseItem[capitalizedKey] = responseItem[reponseItemKey];
          }
        }
      }
      setEarningModal({
        show: true,
        userId: EmployeeId,
        //   paramsData: { Check_Date: Check_Date.split("T")[0], Check_Sequence },
      });
      setMasterContData([{ ...statement }]);
      setDeductionVendor(response);
    } catch (error) {
      ShowError("Something went wrong!");
    } finally {
      setVendorLoader(false);
    }
  };

  const parseDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedMonth = month < 10 ? "0" + month : month;
    const formattedDay = day < 10 ? "0" + day : day;
    const formattedDate = `${formattedMonth}-${formattedDay}-${year}`;
    return formattedDate;
  };

  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          //   return history(`/outside-employment/${props.dataItem.ID}`, {
          //     state: columns,
          //   });
          viewEarningStatementHandler(props.dataItem);
        },
        icon: { iconName: "k-icon  k-i-eye" },
        style: { cursor: "pointer" },
      },

      {
        title: "Timesheet",
        icon: { iconName: "k-icon  k-i-calendar-date" },
        className: "font-primary",
        style: { cursor: "pointer" },
        action: (props) => {
          setOpenTimeSheet(!openTimeSheet);
          setPPEendDate(parseDate(props?.dataItem?.Pay_Period_Ending_date));
          //   dispatch(deleteOutsideEmployeement(Number(props?.dataItem?.ID)));
        },
      },
    ];
  });

  useEffect(() => {
    if (ColumnsSorted[id] !== undefined) {
      setSortedColumns(ColumnsSorted[id]);
    } else {
      if (columns && visileColumns.length > 0 && columns.length > 0) {
        const clms = visileColumns.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(
          filterAllowedColumn(userData, visileColumns.concat(data)),
          "id"
        );
      }
    }
  }, [columns]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(10);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    setPageSize(10);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);
  const toggleDialog = () => {
    setEarningModal({ show: false, userId: "" });
  };

  const handleClickOpen = async () => {
    setOpenModal(true);
  };

  return (
    <Fragment>
      {vendorLoader && loadingPanel()}
      <div style={{ position: "sticky", top: 0, zIndex: 1 }}>
        <Row className="bg-primary  py-2 mb-2">
          <Typography
            variant="h5"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <i className="fa-duotone fa-brain m-r-10"></i> */}
            {!toggleIcon ? (
              <Icon
                size="medium"
                style={{
                  fontSize: "25px",
                  margin: "10px",
                }}
                name="file-ascx"
              />
            ) : (
              <Tooltip
                anchorElement="target"
                position="top"
                style={{ marginLeft: "10px" }}
              >
                <Btn
                  attrBtn={{
                    color: "primary",
                    onClick: () => {
                      openCloseSidebar();
                    },
                    className: "custom-back-button",
                    title: "Back to Menu",
                    style: {
                      fontSize: "18px",
                      outline: "1px solid white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px 8px",
                      paddingRight: "10px",
                      // fontSize: '1rem',
                      cursor: "pointer",
                      marginRight: "6px",
                    },
                  }}
                >
                  <Icon
                    size="medium"
                    style={{
                      fontSize: "25px",
                      marginRight: "5px",
                      // cursor:"pointer",
                    }}
                    name="arrow-left"
                    onClick={openCloseSidebar}
                  />
                  Back
                </Btn>
              </Tooltip>
            )}
            Earning Statement
          </Typography>
          {/* <Typography variant="h5">
							<Icon style={{ fontSize: '25px' }} className="m-r-10" name="file-ascx" />
							Earning Statement
						</Typography> */}
        </Row>
      </div>
      <Container fluid={true}>
        <div>
          <TelerikDataTable
            id={id}
            pageSize={pageSize}
            // totalCount={rowCount}
            skip={(page - 1) * pageSize}
            take={pageSize}
            // data={results || []}
            pageNumber={page}
            sortData={sortData}
            tableName={`EmployeeEarningsStatement-Info2`}
            searchParams={searchParams}
            additionalWhere={additionalWhere}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortChange}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            selectedColumns={sortedColumns}
            setSortedColumns={setSortedColumns}
            // postingResults={deleteResponse}
            // loading={loadingSearch}
            actions={actions}
          />
        </div>
      </Container>

      {earningModal.show && (
        <div className={"EarningHeader"}>
          <Dialog
            title={"Employee earning information"}
            onClose={toggleDialog}
            width={1200}
            height={700}
          >
            <div style={{ marginTop: "5px" }}>
              <Card>
                {masterContData == null ? (
                  loadingPanel()
                ) : masterContData && masterContData.length > 0 ? (
                  <>
                    <CardBody style={{ padding: "40px" }}>
                      <Header
                        data={masterContData}
                        loading={loading}
                        title={"Employee Earnings Statement"}
                      />
                      <Button
                        variant="outlined"
                        onClick={handleClickOpen}
                        style={{ marginRight: "1rem" }}
                      >
                        {"Export(PDF)"}
                      </Button>
                    </CardBody>
                    <CardBody>
                      {masterContData && (
                        <Report
                          data={masterContData}
                          loadingSearch={masterContData == null}
                          deductionVendor={deductionVendor}
                        />
                      )}
                      {openModal && (
                        <PrintPDF
                          pdfName={" Employee Earnings Statement"}
                          rowsData={masterContData}
                          setOpenModal={setOpenModal}
                          ComponentToPrint={
                            <Report
                              data={masterContData}
                              loadingSearch={masterContData == null}
                              deductionVendor={deductionVendor}
                            />
                          }
                          HeaderToPrint={
                            <Header
                              data={masterContData}
                              title={" Employee Earnings Statement"}
                            />
                          }
                        />
                      )}
                    </CardBody>
                  </>
                ) : (
                  <p className="text-center mb-5">No Data Found</p>
                )}
              </Card>
            </div>
          </Dialog>
        </div>
      )}
      {openTimeSheet && (
        <div className={"EarningHeader"}>
          <Dialog
            title={"Timesheet"}
            onClose={() => setOpenTimeSheet(!openTimeSheet)}
            width={1200}
            height={700}
          >
            <div style={{ marginTop: "5px" }}>
              <Card>
                <TimesheetMain ppeEndDate={ppeEndDate} isShow={false} />
              </Card>
            </div>
          </Dialog>
        </div>
      )}
    </Fragment>
  );
};

export default AllEarnings;
